var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFoghorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 94,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 482,
    width: 63,
    height: 94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9526.07,
    y: -0.209615,
    width: 609685,
    height: 905001
  })), /*#__PURE__*/React.createElement("image", {
    width: 97,
    height: 145,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAACRCAMAAADkSiaIAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJkUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBAQAAAAEBAQAAAAABAQAAAAAAAAAAAAAAAAAAAAEBAQICAgMDAwQEBAUFBQYGBgcHBwkJCQwMDA0NDRAQEBISEhcXFxkZGR0dHR4eHh8fHyAgICEhISIiIiMjIyQkJCUlJSYmJigoKCkpKS4uLi8vLzAwMDIyMjU1NTc3Nzs7Ozw8PD09PT8/P0BAQEFBQUJCQkNDQ0ZGRkdHR0hISElJSUtLS0xMTE1NTU5OTk9PT1BQUFJSUlRUVFVVVVZWVldXV1hYWFlZWVpaWltbW1xcXF1dXV5eXl9fX2BgYGFhYWJiYmNjY2RkZGVlZWZmZmdnZ2hoaGlpaW9vb3FxcXJycnR0dHZ2dnt7e35+fn9/f4CAgIWFhYaGhoiIiImJiYqKiouLi42NjY6Ojo+Pj5GRkZOTk5aWlpiYmJqampubm5ycnJ2dnZ6enp+fn6CgoKKioqSkpKWlpaampqioqKurq7CwsLGxsbKysrS0tLW1tba2tre3t7i4uLm5ub29vb6+vr+/v8DAwMHBwcTExMXFxcbGxsjIyMvLy8zMzM3Nzc/Pz9HR0dXV1dbW1tfX19jY2NnZ2dra2tzc3N3d3d7e3t/f3+Dg4OHh4eLi4uTk5Ofn5+np6erq6uvr6+zs7O3t7e7u7u/v7/Dw8PHx8fLy8vPz8/T09PX19ff39/j4+Pn5+fr6+vv7+/z8/P39/f7+/v///9NsgCAAAAAjdFJOUwABBQYHDyQlJjIzPUNJXF1nbHmUp6yyutLX29zh6vP09/z9pMxf1QAAAAlwSFlzAAAOwwAADsMBx2+oZAAAA59JREFUaEPt2odT01AcwHHce+89GhRxguJeIKiAViQtIAo4UIkg7i2K1IUDJxgEFeOgBgVRMWIxVRSU8k/5aH+W5hGLpC8c6vvcNZf05d737qVcQq9+VEfTc8gIQob3hSmVuo02EDOhD0yq0B9GiRgKkyoMgkEiRnaGWT0RLYztCrN6aq9CbImPsp3TeCnsbvRRIdORCw0/YKfR8R12VPhQKAhddsHh3Hu2duHheueeCu2FtzMYZuqjpr3aBQaGOe98U4X2wj3DUqPhdNPe66mzthlSnW+q0Fq4nnXAn/FnUrOQo9PRnjHromvJcFoLxuIHmOJo94VX0Fowy3aMbKIFHC2A/6Hw7oaHh3oUbidb3LJj9SjcOgPrg1TF0YKKdinkr9nltj1ej0JNpYcqPQoYmVV/4NBaMLUsRH+EMSWChcgPMKZEC57+vkLMS1xZBNlCZBrHsREctyc9PZ3jUpZzHLeiGsaUtBaSa+z2/JN2O3rkdtjtIoeWKZUWcElVknTzqCTJtbVfJOn5TkmStpMtmDYlJkaFJgJ2MdoslWBMyddVctHzOrjQApyIoQVAC24dt5BwPS/v0I48cG492qwje4+Lz7FY9m+2WC7l5uZaLCcj0X8phO/Tv1aJ3uO8FTbl8/ypDJ4vLCoq4vlrLM/zsWSvg/HYcdyqKhhT0lowoVXCbKUFHC2A/6HwyVrarFyPwtOwDLc94bIOBWEfLA9ii6EFFe1SeLIu2+3saj0K1QV3mj2kf9MqaAH88wW2ugaXQrawIZZlo8NZljWZTCy7IQztLXoPY0paC+7nVoejgT57t1ao022VWNZsjlhuBuvno80Swt8v2WT57gkZvEhDG51WyUXP6+BCC3AihhYALbjRgmt+fQrmvZmZCWszQdpKtAkl+93MllJRvHJQFMvfvKkUxeIkURQ367NKf+l9+rMV2fhYEHL2C8Jzq7VUEO4mCIIQV2K1ynCOBw2FKH+EaXo1bVych+gV0fKXXhoK8wwhi9XNNwQ1wEnNNBXKfqgrZwgU6uvq5hpewQHuNRP0rQ7/tUAbC1dDgoOneClMCQ5eeB+OQBsLR6YFBATMUf9YNjbagtBo4GU4Am0sfK+sqKiwwUFLNjT6Fvs4abjSbUQLf4IW/kSrhdSvPiporRA420czndN4KRCif2FMF5jV00AYJGIYTKrQYzyMEjBpAEyq1G/UxMlETBo3uBPMienSvTcRvbr9JkBRHZqf30/8rSsYAD3iuQAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 599042,
    height: 895475
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-532 -482)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000104972 0 0 0.000104972 532 482)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1.00186 0 0 1 0.0820312 -0.0823264)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(6175.69 6175.69)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoghorn);
export default __webpack_public_path__ + "static/media/Foghorn.c811c8afa855c3b53aae914e75519ba2.svg";
export { ForwardRef as ReactComponent };